import React from "react";
import register from "../../images/school/icons/register.png";
import support from "../../images/school/icons/support.png";
import recommendation from "../../images/school/icons/recommendation.png";
import continues from "../../images/school/icons/continues.png";
import consult from "../../images/school/icons/consult.png";

const stepsContent = [
  {
    id: 1,
    img: register,
    head: "Register",
    h1: (
      <span>
        Fill out the registration <br></br>form
      </span>
    ),
    p: "Express interest and provide basic school information",
  },
  {
    id: 2,
    img: consult,
    head: "Consultation meeting",
    h1: "Schedule and attend a consultation",
    p: "Discuss needs, challenges, and program options",
  },
  {
    id: 3,
    img: recommendation,
    head: (
      <span>
        <span className="font-bold text-3xl">SAIL program:</span>
        <br />
        {/* "Comprehensive assessments and personalized recommendations" */}
      </span>
    ),
    h1: "Refer students for detailed assessments",
    p: "Receive individualized learning plans and recommendations",
  },
  {
    id: 4,
    img: support,
    head: (
      <span>
        <span className="font-bold text-3xl">CoMPASS program:</span>
        <br />
        {/* "Integrated support and collaboration" */}
      </span>
    ),
    h1: "Engage in continuous collaboration",
    li: [
      "Central coordination by ELiNA",
      "Regular monitoring and adjustments",
      "Use of ISMS tool for tracking and communication",
    ],
  },
  {
    id: 5,
    img: continues,
    head: "Continuous support",
    h1: " Maintain communication with ELiNA",
    p: "Ensure ongoing student development and support",
  },
];

const StepsSchools = () => {
  return (
    <>
      <div className="HeroBg2">
        <div className="flex flex-col items-center justify-center pt-[10%] pb-[5%] px-[5%] lg:px-[8%]">
          <h1 className="text-center text-5xl md:text-6xl lg:text-7xl font-bold text-blue-700">
            Getting started is simple
          </h1>
        </div>
        <div className="flex items-center justify-center pb-[5%]">
          <div className="flex lg:flex-row flex-col w-[90%] gap-5  flex-wrap  justify-center text-center ">
            {stepsContent?.map((item, index) => (
              <div className="lg:w-[32%] w-full flex flex-col gap-5  bg-blue-600 bg-opacity-10 rounded-3xl p-10 justify-between lg:h-[200px]]">
                <p className="font-bold text-4xl ">{item.id}</p>
                <div className="flex flex-col gap-5 lg:gap-8 ">
                  <h1 className="text-3xl  font-bold">
                    <div className="flex justify-center p-3 lg:pb-8">
                      <img className=" w-16" src={item.img} alt={item.head} />
                    </div>
                    <div className="text-pink-500">{item.head}</div>
                  </h1>
                  <div className="">{item.main && <p>{item.main}</p>}</div>
                  <div>
                    <h1 className="text-2xl font-bold">{item.h1}</h1>
                  </div>

                  {item.li && (
                    <div className="text-center ">
                      {item.li.map((i) => (
                        <p>{i}</p>
                      ))}
                    </div>
                  )}
                </div>
                {!item.li && (
                  <div className="my-auto ">
                    <p className="text-lg">{item.p}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default StepsSchools;
